import { useCarestackDashboard } from 'app/components/carestack-dashboard/useCarestackDashboard'
import { CarestackDashboardShadcnComponent } from 'app/components/carestack-dashboard/CarestackDashboardShadcnComponent'

export default function SettingsProducts(): React.ReactElement {
  const { base64, workspaces, groupBy, onGroupChange } = useCarestackDashboard()

  return (
    <CarestackDashboardShadcnComponent
      base64={base64}
      workspaces={workspaces}
      groupBy={groupBy}
      onGroupChange={onGroupChange}
    />
  )
}
